import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './index.css';
import { requestPersistentStorage } from './lib/persistent-storage';
import { startCapturingInstallPrompt } from './shared/pwa/install-prompt-store';
import { startWatchingServiceWorker } from './shared/pwa/sw-update-store';

// Before render: Chromium fires beforeinstallprompt once, early, and a
// listener added from a component would usually miss it.
startCapturingInstallPrompt();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registered only in production builds: a service worker fighting Vite's dev
// server / HMR causes stale-module bugs that are hard to tell apart from real
// ones. Deliberately no skipWaiting()/clients.claim() on the SW side, so a
// deploy that lands while a student is mid-attempt never swaps the running
// bundle under them — see public/sw.js for the full lifecycle note.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Installability/offline is a progressive enhancement — the app works
         fully without it, so a registration failure is not user-facing. */
    });
    // Notices a newer build sitting in "waiting" and surfaces the reload toast;
    // activation still happens only on the user's tap (see sw-update-store).
    startWatchingServiceWorker();
  });
}

// Before anything else touches storage: the auth refresh token is only as
// durable as localStorage, and an evicted token reads to the user as a session
// that expired on its own. See src/lib/persistent-storage.ts.
requestPersistentStorage();
